import { render, staticRenderFns } from "./AvailablePricing.vue?vue&type=template&id=87bcbd98&scoped=true"
import script from "./AvailablePricing.vue?vue&type=script&lang=js"
export * from "./AvailablePricing.vue?vue&type=script&lang=js"
import style0 from "./AvailablePricing.vue?vue&type=style&index=0&id=87bcbd98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bcbd98",
  null
  
)

export default component.exports